/* odaban® Story · Glossar – Suche, A–Z, Aufklappen, Sprungmarken (#begriff), Parallax, Einblenden.
   Wird von jedem Glossar-Abschnitt eingebunden, läuft aber nur einmal pro Seite und arbeitet über alle Kapitel. */
(function () {
  'use strict';
  if (window.__ogl) return;
  window.__ogl = 1;

  var d = document, w = window;
  var rm = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var EASE = 'cubic-bezier(.22,1,.36,1)';
  var q = '', letter = '', timer = 0;

  function $(s, c) { return [].slice.call((c || d).querySelectorAll(s)); }
  function esc(v) { return String(v).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* Umlaute und ae/oe/ue gleich behandeln, damit „schweiss“, „Schweiß“ und „schweis“ dasselbe finden */
  function norm(v) {
    return (v || '').toLowerCase()
      .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss')
      .replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function dec(v) { try { return decodeURIComponent(v || ''); } catch (e) { return v || ''; } }
  function tools() { return d.querySelector('[data-ogl-tools]'); }
  function terms() { return $('[data-ogl-term]'); }
  function input() { var t = tools(); return t ? t.querySelector('[data-ogl-q]') : null; }
  /* Begriff über seine Anker-ID finden – unabhängig davon, ob dieselbe ID noch woanders auf der Seite vorkommt */
  function byId(id) {
    if (!id) return null;
    var ts = terms();
    for (var i = 0; i < ts.length; i++) if (ts[i].id === id) return ts[i];
    return null;
  }

  /* ---------- Aufklappen: Höhe weich animieren ---------- */
  function setOpen(t, open, instant) {
    if (!t || t.classList.contains('ogl-t--flat')) return;
    var btn = t.querySelector('[data-ogl-toggle]'), x = t.querySelector('[data-ogl-x]');
    if (t._a) { var to = t._to; t._a.onfinish = null; t._a.cancel(); t._a = null; t.style.overflow = ''; t.classList.toggle('is-open', to); }
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (t.classList.contains('is-open') === open) return;
    if (instant || rm || !t.animate) { t.classList.toggle('is-open', open); return; }
    var h0 = t.getBoundingClientRect().height, h1;
    if (open) {
      t.classList.add('is-open');
      h1 = t.getBoundingClientRect().height;
      if (x && x.animate) x.animate({ opacity: [0, 1], transform: ['translateY(-6px)', 'none'] }, { duration: 380, delay: 80, easing: EASE, fill: 'backwards' });
    } else {
      t.classList.remove('is-open');
      h1 = t.getBoundingClientRect().height;
      t.classList.add('is-open');
    }
    t.style.overflow = 'hidden';
    t._to = open;
    var a = t.animate({ height: [h0 + 'px', h1 + 'px'] }, { duration: open ? 460 : 340, easing: EASE });
    t._a = a;
    a.onfinish = function () { t._a = null; t.style.overflow = ''; t.classList.toggle('is-open', open); };
  }
  function setHash(id) {
    if (!w.history || !history.replaceState) return;
    try { history.replaceState(null, '', id ? '#' + id : location.pathname + location.search); } catch (e) {}
  }
  function toggle(t) {
    var open = !t.classList.contains('is-open');
    setOpen(t, open);
    if (open) setHash(t.id); else if (location.hash === '#' + t.id) setHash('');
  }

  /* ---------- Sprung zu einem Begriff (#hyperhidrose, verwandte Begriffe) ---------- */
  function jump(id, smooth) {
    var t = byId(id);
    if (!t) return false;
    if (t.hidden) { q = ''; letter = ''; var i = input(); if (i) i.value = ''; apply(); }
    setOpen(t, true, true);
    t.scrollIntoView({ behavior: smooth && !rm ? 'smooth' : 'auto', block: 'start' });
    t.classList.remove('is-hit'); void t.offsetWidth; t.classList.add('is-hit');
    setHash(id);
    return true;
  }

  /* ---------- Suche und Buchstabenfilter ---------- */
  function apply() {
    var ts = terms(), toks = norm(q).split(' ').filter(Boolean), n = 0;
    ts.forEach(function (t) {
      if (t._b == null) {
        var nEl = t.querySelector('.ogl-t__n'), aEl = t.querySelector('.ogl-t__also');
        t._h = norm((nEl ? nEl.textContent : '') + ' ' + (aEl ? aEl.textContent : '') + ' ' + (t.getAttribute('data-k') || ''));
        t._b = norm(t.textContent + ' ' + (t.getAttribute('data-k') || ''));
      }
      t._ok = true; t._top = false;
      if (toks.length) {
        t._ok = toks.every(function (k) { return t._b.indexOf(k) > -1; });
        t._top = t._ok && toks.every(function (k) { return t._h.indexOf(k) > -1; });
      } else if (letter) t._ok = t.getAttribute('data-l') === letter;
    });
    /* Steht das Suchwort in Begriffen oder Synonymen, zählen nur diese Treffer – sonst der ganze Text */
    var named = toks.length && ts.some(function (t) { return t._top; });
    ts.forEach(function (t) {
      var ok = named ? t._top : t._ok;
      t.hidden = !ok;
      if (ok) n++;
    });
    var filt = !!(toks.length || letter);
    $('[data-ogl]').forEach(function (r) { r.classList.toggle('ogl--filter', filt); });
    $('[data-ogl-chapter]').forEach(function (c) {
      var any = $('[data-ogl-term]', c).some(function (t) { return !t.hidden; });
      c.hidden = filt && !any;
    });
    status(n, ts.length, toks.length > 0);
    $('[data-ogl-l]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-ogl-l') === letter && !toks.length ? 'true' : 'false'); });
  }
  function status(n, total, hasQ) {
    var tl = tools(); if (!tl) return;
    var st = tl.querySelector('[data-ogl-status]'), rs = tl.querySelector('[data-ogl-reset]'), em = tl.querySelector('[data-ogl-empty]'), cl = tl.querySelector('[data-ogl-clear]');
    var txt = tl.getAttribute('data-t-all') || '';
    if (hasQ) txt = tl.getAttribute(n ? 'data-t-hits' : 'data-t-none') || '';
    else if (letter) txt = tl.getAttribute('data-t-letter') || '';
    if (st) st.textContent = txt.replace('[n]', n).replace('[total]', total).replace('[q]', q.trim()).replace('[l]', letter);
    if (rs) rs.hidden = !(hasQ || letter);
    if (cl) cl.hidden = !q;
    if (em) em.hidden = !!n || !hasQ;
  }
  function buildAZ() {
    var tl = tools(); if (!tl) return;
    var nav = tl.querySelector('[data-ogl-az]'); if (!nav) return;
    var has = {};
    terms().forEach(function (t) { has[t.getAttribute('data-l')] = 1; });
    var h = '<button type="button" class="ogl-az__all" data-ogl-l="" aria-pressed="true">' + esc(nav.getAttribute('data-all') || 'Alle') + '</button>';
    'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach(function (c) {
      h += '<button type="button" data-ogl-l="' + c + '" aria-pressed="false"' + (has[c] ? '' : ' disabled') + '>' + c + '</button>';
    });
    nav.innerHTML = h;
  }
  function clean() {
    /* Verweise auf Begriffe, die es auf der Seite nicht gibt, ausblenden */
    $('[data-ogl-go]').forEach(function (a) {
      a.hidden = !byId(dec((a.getAttribute('href') || '').split('#')[1]));
    });
    $('.ogl-rel').forEach(function (r) { r.hidden = !$('[data-ogl-go]', r).some(function (a) { return !a.hidden; }); });
  }

  /* ---------- Einblenden, Verlauf, Parallax ---------- */
  var io = 'IntersectionObserver' in w;
  var rv = io ? new IntersectionObserver(function (en) {
    en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); rv.unobserve(x.target); } });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }) : null;
  var gv = io ? new IntersectionObserver(function (en) {
    en.forEach(function (x) { x.target.classList.toggle('is-live', x.isIntersecting); });
  }) : null;
  var pxEls = [], tick = 0;
  function pxMove() {
    tick = 0;
    var vh = w.innerHeight;
    pxEls.forEach(function (f) {
      var r = f.getBoundingClientRect();
      if (!r.height || r.bottom < 0 || r.top > vh) return;
      var p = ((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2);
      p = Math.max(-1, Math.min(1, p));
      /* Bild ist um 2·k vergrößert und wandert höchstens k der Höhe: der Rahmen bleibt immer gefüllt */
      f._im.style.transform = 'translate3d(0,' + (p * f._k * -100).toFixed(2) + '%,0) scale(' + (1 + f._k * 2).toFixed(3) + ')';
    });
  }
  function fx() {
    $('.ogl-rv').forEach(function (el) {
      if (el._o) return; el._o = 1;
      if (!rv || rm) el.classList.add('is-in'); else rv.observe(el);
    });
    $('.ogl-gbg').forEach(function (el) {
      if (el._o) return; el._o = 1;
      if (!gv) el.classList.add('is-live'); else gv.observe(el);
    });
    pxEls = rm ? [] : $('[data-ogl-px]').filter(function (f) {
      f._im = f.querySelector('img');
      f._k = (parseFloat(f.getAttribute('data-ogl-px')) || 0) / 100;
      return f._im && f._k > 0;
    });
    if (pxEls.length) pxMove();
  }

  /* ---------- Ereignisse ---------- */
  d.addEventListener('click', function (e) {
    var el = e.target;
    if (!el.closest) return;
    var go = el.closest('[data-ogl-go]');
    if (go) {
      if (jump(dec((go.getAttribute('href') || '').split('#')[1]), true)) e.preventDefault();
      return;
    }
    var lb = el.closest('[data-ogl-l]');
    if (lb) {
      var v = lb.getAttribute('data-ogl-l');
      letter = v === letter ? '' : v;
      q = ''; var i = input(); if (i) i.value = '';
      apply();
      return;
    }
    if (el.closest('[data-ogl-clear]') || el.closest('[data-ogl-reset]')) {
      q = ''; letter = ''; var i2 = input(); if (i2) { i2.value = ''; if (el.closest('[data-ogl-clear]')) i2.focus(); }
      apply();
      return;
    }
    var t = el.closest('[data-ogl-term]');
    if (!t) return;
    if (el.closest('[data-ogl-toggle]')) { e.preventDefault(); toggle(t); return; }
    if (!t.classList.contains('is-open') && !el.closest('a,button,input')) {
      var sel = w.getSelection ? String(w.getSelection()) : '';
      if (!sel) toggle(t);
    }
  });
  d.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-ogl-q]')) return;
    var v = e.target.value;
    clearTimeout(timer);
    timer = setTimeout(function () { q = v; letter = ''; apply(); }, 90);
  });
  d.addEventListener('keydown', function (e) {
    if (!e.target.matches || !e.target.matches('[data-ogl-q]')) return;
    if (e.key === 'Escape') { e.target.value = ''; q = ''; apply(); }
    if (e.key === 'Enter') {
      e.preventDefault();
      clearTimeout(timer); q = e.target.value; letter = ''; apply();
      e.target.blur();
      var first = terms().filter(function (t) { return !t.hidden; })[0];
      if (q.trim() && first) first.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'start' });
    }
  });
  w.addEventListener('scroll', function () { if (pxEls.length && !tick) tick = w.requestAnimationFrame(pxMove); }, { passive: true });
  w.addEventListener('resize', function () { if (pxEls.length && !tick) tick = w.requestAnimationFrame(pxMove); }, { passive: true });
  w.addEventListener('hashchange', function () { jump(dec(location.hash.slice(1)), true); });

  /* Theme-Editor: nach Änderungen neu aufbauen, gewählten Begriff aufklappen */
  d.addEventListener('shopify:section:load', function () { setTimeout(init, 0); });
  d.addEventListener('shopify:section:unload', function () { setTimeout(init, 0); });
  d.addEventListener('shopify:block:select', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-ogl-term]');
    if (t) { if (t.hidden) { q = ''; letter = ''; apply(); } setOpen(t, true, true); }
  });

  function init() {
    terms().forEach(function (t) {
      t._b = null;
      var b = t.querySelector('[data-ogl-toggle]');
      if (b && !b.hasAttribute('aria-expanded')) b.setAttribute('aria-expanded', t.classList.contains('is-open') ? 'true' : 'false');
    });
    buildAZ(); clean(); apply(); fx();
  }
  function start() {
    init();
    if (location.hash) jump(dec(location.hash.slice(1)), false);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();
